export default class Currency {

    static format(price) {
        if (price == null) {
            return
        }

        let p = parseFloat(price.toString().replace(',', '.'));

        return p.toLocaleString(_CORE.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }
}

